import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Cateringsubscriptiongallery from "./Cateringsubscriptiongallery";
import Catringsubscription from "../../Subscriptions/Catringsubscription";

// Import your catering images
import img1 from "./download.jpg";
import img2 from "./Cloudimages/catren.jpg";
import img3 from "./Cloudimages/cat1.jpg";
import img4 from "./Cloudimages/booking.webp";

const Cateringbanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <style>{`
        /* Catering Banner Styles */

        .catering-banner-top {
          text-align: center;
          margin-bottom: 30px;
          margin-top: -40px;
          max-width: 1017px;
          margin-left: auto;
          margin-right: auto;
        }

        .catering-banner-top h1 {
          font-size: 3rem;
          font-weight: bold;
          line-height: 1.2;
          margin-bottom: 15px;
          color: #333;
        }

        .catering-banner-top p {
          font-size: 1.1rem;
          line-height: 1.6;
          margin-bottom: 20px;
          color: #666;
        }

        /* Slider Section */
        .catering-banner-slider {
          width: 100%;
          max-width: 1000px;
          margin: 0 auto;
        }

        .catering-slide {
          position: relative;
          height: 420px;
        }

        .catering-slide img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 14px;
        }

        .catering-slide-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.45);
          border-radius: 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #fff;
          padding: 20px;
        }

        .catering-slide-overlay h2 {
          font-size: 2rem;
          margin-bottom: 12px;
        }

        .catering-slide-overlay p {
          font-size: 1rem;
          max-width: 650px;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .catering-banner-top h1 {
            font-size: 2.4rem;
          }
          .catering-slide {
            height: 320px;
          }
        }

        @media (max-width: 600px) {
          .catering-banner-top h1 {
            font-size: 1.9rem;
          }
          .catering-banner-top p {
            font-size: 0.95rem;
          }
          .catering-slide {
            height: 220px;
          }
          .catering-slide-overlay h2 {
            font-size: 1.3rem;
          }
          .catering-slide-overlay p {
            font-size: 0.85rem;
          }
        }
      `}</style>

      {/* Banner Text Section */}


      {/* Slider Section */}
      <div className="catering-banner-slider" style={{ marginTop: "-50px" }}>
        <Slider {...settings}>
          <div className="catering-slide">
            <img src={img1} alt="Catering Service 1" />
            <div className="catering-slide-overlay">
              <h2>Wedding Catering</h2>
              <p>Elegant dining experience with customized menus for your big day.</p>
            </div>
          </div>
          <div className="catering-slide">
            <img src={img2} alt="Catering Service 2" />
            <div className="catering-slide-overlay">
              <h2>Corporate Catering</h2>
              <p>Professional service and delicious meals for business meetings & events.</p>
            </div>
          </div>
          <div className="catering-slide">
            <img src={img3} alt="Catering Service 3" />
            <div className="catering-slide-overlay">
              <h2>Birthday Parties</h2>
              <p>Celebrate with tasty food, snacks, and sweet delights for your guests.</p>
            </div>
          </div>
          <div className="catering-slide">
            <img src={img4} alt="Catering Service 4" />
            <div className="catering-slide-overlay">
              <h2>Special Occasions</h2>
              <p>From anniversaries to private gatherings, we bring flavor to every event.</p>
            </div>
          </div>
        </Slider>
      </div>

      {/* Other Components Below */}
      <div style={{ marginTop: "25px" }}>
        <Cateringsubscriptiongallery />
      </div>
      <div style={{ marginTop: "25px" }}>
        <Catringsubscription />
      </div>
    </>
  );
};

export default Cateringbanner;
